export default "__VITE_ASSET__CIixgew4__"